module.exports = __webpack_public_path__ + "media/illustrations/product-thumb-generic-free-gift-0ff04f64.svg";